import { render, staticRenderFns } from "./AllIssueFooter.vue?vue&type=template&id=5dca39b8&scoped=true"
import script from "./AllIssueFooter.vue?vue&type=script&lang=js"
export * from "./AllIssueFooter.vue?vue&type=script&lang=js"
import style0 from "./AllIssueFooter.vue?vue&type=style&index=0&id=5dca39b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca39b8",
  null
  
)

export default component.exports